import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

interface NoDataScoreProps {
  className?: string;
  /** The data row's own reason, when it has one (e.g. Changing
   * Precipitation's dry-site note); replaces the generic tooltip. */
  reason?: string;
}

const NO_DATA_REASON =
  "This hazard's data source doesn't cover this scenario/horizon combination yet — a genuine data gap, distinct from \"pending\" (which means the risk inputs exist but haven't been combined yet) and from \"N/A\" (which means this hazard doesn't apply here at all).";

/** Sibling to PendingScore for a status: "no_data" cell — same visual
 * treatment as PendingScore (dashed border, muted background), differing
 * only in label/tooltip text, since both mean "no colored score here" but
 * for different reasons — see
 * docs/superpowers/specs/2026-09-13-tab3-by-asset-view-design.md. */
export function NoDataScore({ className, reason }: NoDataScoreProps) {
  return (
    <Badge
      title={reason || NO_DATA_REASON}
      className={cn("border-dashed border-muted-foreground/40 bg-muted text-muted-foreground", className)}
    >
      No data
    </Badge>
  );
}
